import { ImageSlideProps } from '../../../types';

export const ImageSlider = (props: ImageSlideProps) => {
    const { slideToDisplay, classNames = '', swipeHandlers = {} } = props;

    return (
        <img
            {...swipeHandlers}
            src={`${slideToDisplay.url}`}
            alt=""
            className={`h-full w-full block mx-auto object-contain bc:object-top ${classNames}`}
            data-testid="PresentationSlide"
        />
    );
};
